<template>
  <div>
    <custom-section title="Información de Cita">
      <div class="row">
        <div class="col-2">
          <info title="Día:">
            <label class="appnt-content">{{ appointment.date }}</label>
          </info>
        </div>
        <div class="col-2">
          <info title="Horario:">
            <label class="appnt-content">{{ appointment.schedule }}</label>
          </info>
        </div>
        <div class="col-2">
          <info title="Municipio:">
            <label class="appnt-content">
              {{ appointment.municipalityName }}
            </label>
          </info>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <info title="Comentario de Razón de Aprobación:">
            <label class="appnt-content">{{ appointment.comment }}</label>
          </info>
        </div>
      </div>
    </custom-section>
    <custom-section class="mt-3" title="Información Contacto">
      <div class="row pb-3 bottom-line">
        <div class="col-2">
          <info title="Nombre:">
            <label class="appnt-content">{{ appointment.contactName }}</label>
          </info>
        </div>
        <div class="col-2">
          <info title="Parentesco:">
            <label class="appnt-content">
              {{ appointment.relationshipName }}
            </label>
          </info>
        </div>
        <div class="col-2">
          <info title="Correo Electrónico:">
            <label class="appnt-content">{{ appointment.email }}</label>
          </info>
        </div>
        <div class="col-2">
          <info title="Teléfono:">
            <label class="appnt-content">{{ appointment.phone }}</label>
          </info>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-2">
          <info title="Especialista:">
            <label class="appnt-content">
              {{ appointment.serviceSpecialist }}
            </label>
          </info>
        </div>
        <div class="col-2">
          <info title="Lugar de Servicio:">
            <label class="appnt-content">{{ appointment.servicePlace }}</label>
          </info>
        </div>
        <div class="col-2">
          <info title="Número de Contacto:">
            <label class="appnt-content">
              {{ appointment.servicePlaceContactPhone }}
            </label>
          </info>
        </div>
        <div class="col-2">
          <info title="Dirección Física:">
            <label class="appnt-content">
              {{ appointment.physicalAddress }}
            </label>
          </info>
        </div>
      </div>
    </custom-section>
  </div>
</template>

<script>
import Info from './Info.vue';
import CustomSection from './CustomSection.vue';

export default {
  components: {
    Info,
    CustomSection,
  },
  props: {
    appointment: { type: Object, require: true, default: () => ({}) },
  },
};
</script>

<style scope>
.bottom-line {
  border-bottom: 1px solid #e2e2e2;
}
.appnt-content {
  color: #11291b;
}
</style>
